import axios from "axios";
import { ENV } from "@/config/env";
import { STORAGE_KEYS } from "@/config/constants";
import { storage } from "@/shared/utils/storage";

const api = axios.create({
  baseURL: ENV.API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

let logoutHandler: (() => void) | null = null;
export const injectLogout = (handler: () => void) => {
  logoutHandler = handler;
};

api.interceptors.request.use(
  (config) => {
    try {
      const secureToken = storage.get(STORAGE_KEYS.SECURE_TOKEN);
      if (secureToken) {
        const cleanToken = secureToken.replace(/["']/g, "").trim();
        config.headers.Authorization = `Bearer ${cleanToken}`;
        config.headers["x-app-identity"] = cleanToken;
      }
    } catch (error) {
      console.error("Interceptor Request Error:", error);
    }
    return config;
  },
  (error) => Promise.reject(error),
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 403 && error.response?.data?.code === "activation_required") {
      const user = storage.getJSON<Record<string, unknown>>(STORAGE_KEYS.USER_DATA);
      if (user) storage.setJSON(STORAGE_KEYS.USER_DATA, { ...user, emailPending: true });
      if (window.location.pathname !== "/activate") window.location.assign("/activate");
    }
    if (error.response?.status === 401) {
      console.warn("401 Unauthorized detected.");
      if (logoutHandler) logoutHandler();
    }
    return Promise.reject(error);
  },
);

export default api;
